import React from "react";
import { MODULE_CATEGORIES, BADGE_CLASSES, CATEGORY_BADGES } from "@/data/moduleCatalog";

export const CategoryBadge = ({ badge }) => (
  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wide ${BADGE_CLASSES[badge]}`}>
    {CATEGORY_BADGES[badge]}
  </span>
);

export const ModuleCard = ({ module, badge, actions, testid = "module-card" }) => (
  <div
    className="group rounded-3xl bg-white/80 border border-[var(--border)] overflow-hidden flex flex-col shadow-sm transition-[transform,box-shadow] duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] hover:shadow-lg hover:-translate-y-1"
    data-testid={`${testid}-${module.key}`}
  >
    <div className="h-56 sm:h-64 w-full overflow-hidden bg-[var(--sand)]">
      <img
        src={`/modules/${module.key}.jpg`}
        alt=""
        loading="lazy"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
      />
    </div>
    <div className="p-6 sm:p-7 flex flex-col flex-1">
      <div className="mb-3">
        <CategoryBadge badge={badge} />
      </div>
      <h3 className="font-serif-title text-xl sm:text-2xl text-[var(--accent-deep)] group-hover:text-[var(--gold)] transition-colors leading-snug mb-2.5">
        {module.title}
      </h3>
      <p className="text-sm text-[var(--ink-soft)] leading-relaxed mb-6 flex-1">{module.description}</p>
      <div className="mt-auto">{actions}</div>
    </div>
  </div>
);

export const ModuleCatalog = ({ renderActions, cardTestid = "module-card", categories = MODULE_CATEGORIES }) => (
  <div className="space-y-14 sm:space-y-16">
    {categories.map((cat) => (
      <section key={cat.id} data-testid={`category-section-${cat.id}`}>
        <div className="mb-6">
          <h2 className="font-serif-title text-2xl sm:text-3xl text-[var(--gold)] mb-2 flex items-center gap-4">
            <span className="whitespace-nowrap">{cat.title}</span>
            <span className="h-px flex-1 bg-[var(--border)]" />
          </h2>
          <p className="text-sm text-[var(--ink-soft)] leading-relaxed max-w-2xl">{cat.intro}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {cat.modules.map((m) => (
            <ModuleCard key={m.key} module={m} badge={m.badge || cat.badge} testid={cardTestid} actions={renderActions(m)} />
          ))}
        </div>
      </section>
    ))}
  </div>
);
